import Axios from 'axios';

const axios = Axios.create({
	// baseURL: 'http://localhost/api/',
	baseURL: process.env.REACT_APP_BASE_URL,
	withCredentials: true,
});

export default axios;
